import React, { Component } from "react";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import DropDownList from "../DropDownList/DropDownList";
import DropDownListNew from "../DropDownList/DropDownListNew";
import EditCommand from "../Commands/EditCommand/EditCommand";
import DeleteCommand from "../Commands/DeleteCommand/DeleteCommand";
import OpenCommand from "../Commands/OpenCommand/OpenCommand";
import ReduceDashCommand from "../Commands/ReduceDashCommand/ReduceDashCommand";
import DotCommand from "../Commands/DotCommand/DotCommand";

import MenuDots from "../MenuDots/MenuDots";
import "./AccordionItem.css";

class AccordionItem extends Component {
  onDropDownItemClick = (itemSelected, currentItem) => {
    this.props.onDropDownItemClick(itemSelected, currentItem);
  };
  onMenuItemClick = (menuItem, currentOrder) => {
    this.props.onMenuItemClick(menuItem, currentOrder);
  };

  getWidth =()=> {
    
    return this.props.isNodeWithCondition ? "40%"
      : "80%";
  };
  
  render() {
    
    return (
      <div className="accordionItem" onMouseOver={this.props.onMouseOver}>
        <div className="leftColumn">
          <div
            className="accordionIcone"
            onClick={this.props.onExpandCollapseClick}
            style={{
              visibility: this.props.isMenuHasChilds ? "visible" : "hidden",
            }}
          >
            <OpenCommand isShow={!this.props.isExpanded} isStandard={false} />
            <ReduceDashCommand
              isShow={this.props.isExpanded}
              isStandard={false}
            />
          </div>
        </div>

        <div className="middleColumn" style={{ width: this.getWidth() }}>
          
          {this.props.items.data.map((currentItem) => (
            <div
              key={currentItem.id}
              className="accordionText"
              style={{ width: this.props.items.width[currentItem.order] }}>
              <DropDownListNew
                currentData={this.props.lists[currentItem.list]}
                initialValue={currentItem.item.item}
                color = {this.props.isInTree ? "#212121" : "rgb(206, 17, 38)"  }
                id={"Accordion" && currentItem.id}
                defaultListColor = {true}
                onDropDownItemClick={(itemSelected) =>
                  this.onDropDownItemClick(itemSelected, currentItem)
                }
              />
            </div>
          ))}
          
        </div>
        {this.props.isNodeWithCondition && 
          <div className="decisionColumn">
            <input
              className="textBoxWithoutBorder"
              value={this.props.conditionDescription ? this.props.conditionDescription : "Decision ?"}
            
              onChange={(e) => this.props.onChangeConditionDescription(e.target.value)  }
              />
          </div>}
        <div className="menuColumn">
          <MenuDots
            isMenuVisible={this.props.isMenuVisible}
            width={this.props.menuList.width}
            currentData={this.props.menuList.list}
            onMenuItemClick={(menuItem) => this.onMenuItemClick(menuItem)}
          />
        </div>
      </div>
    );
  }
}

export default AccordionItem;
